import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { cn } from '../../../lib/utils';
import { SpecraActivityRow } from '../lieutenants/activity-row';
import { SpecraEmptyState } from '../lieutenants/empty-state';
/** Read-only audit and activity stream with consistent empty behavior. */ export function SpecraActivityFeed({ className, emptyText = 'No activity yet.', getItemProps, getItemTestId, items, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('divide-y divide-border', className),
        ...props,
        children: [
            items.map((item, index)=>/*#__PURE__*/ _createElement(SpecraActivityRow, {
                    ...item,
                    ...getItemProps?.(item),
                    "data-item-id": item.id,
                    "data-testid": getItemTestId?.(item),
                    key: item.id ?? `${String(item.title)}-${index}`
                })),
            items.length === 0 ? /*#__PURE__*/ _jsx(SpecraEmptyState, {
                title: emptyText
            }) : null
        ]
    });
}
